import { Paper } from "@mantine/core";
import EditNoteContent from "./EditNoteContent";
import AddNoteContent from "./AddNoteContent";
import NoteAttachments from "./NoteAttachments";

const NoteItemContent = ({
  item,
  isEdit,
  setIsEdit,
  outsideCurrent,
  outsideContainer,
  small,
}) => {  
  return (
    <Paper
      withBorder
      p={0}
      fz={"sm"}
      mb={"xl"}
      bg={"#ffaa0012"}
      mt={10}
      w={"100%"}
      pos={"relative"}
    >
      {isEdit ? (
        <EditNoteContent
          setIsEdit={setIsEdit}
          item={item}
          outsideCurrent={outsideCurrent}
          container={outsideContainer}
          small={small}
        />
      ) : item?.isCreate ? (
        <AddNoteContent />
      ) : (
        <>
          <iframe
            onLoad={(e) => {
              let contentHeight =
                e.target.contentWindow.document.body.scrollHeight + 16;
              e.target.style.height = contentHeight + "px";
            }}
            title={`note-${item?.id}`}
            srcDoc={`
        <head>
          <style>
            p { margin: 0 }
          </style>
        </head>
        <div style="font-family: sans-serif; font-size: 13px;">${item.note}</div>
        `}
            style={{
              width: "100%",
              border: "none",
              height: "100%",
              minHeight: 100,
            }}
            // sandbox=""
          />

          <NoteAttachments
            files={item?.attachments?.map((x) => ({
              ...x,
              name: x?.filename,
              size: x?.file_size,
            }))}
          />
        </>
      )}
    </Paper>
  );
};

export default NoteItemContent;
